/**
 * 门户文本默认配置数据
 */
export const home = [
  {},
  {
    styleId:2,
    imgSrc: "https://p.ananas.chaoxing.com/star3/origin/8f5e8cc5db4125f40aed873f2ed31a9d.png",
    shapeType: "radius", // square， radius， round
    borderRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10
  },
  {
    styleId:3,
    height: 200,
    shapeType: "rect"
  },
  {
    styleId:3,
    height: 200,
    shapeType: "round", // square， radius， round
    borderRadius: "50%",
    borderTopLeftRadius: "50%",
    borderTopRightRadius: "50%",
    borderBottomLeftRadius: "50%",
    borderBottomRightRadius: "50%"
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {
    borderWidth: 0,
    imgSrc: "https://p.ananas.chaoxing.com/star3/origin/eae996e96ac03422583306fb9f081958.png",
    hoverImgSrc: "",
    iconColor: "#e9e9e9"
  },
  {
    styleId:2,
    width: 200,
    height: 150,
    borderRadius:8,
    imgName: "圆角矩形",
    shapeType: "radius",
    iconColor: "#e9e9e9"
  },
  {
    styleId:3,
    width: 150,
    height: 200,
    borderRadius:8,
    imgName: "圆角矩形",
    shapeType: "radius",
    iconColor: "#e9e9e9"
  },
  {
    styleId:4,
    imgName: "圆形",
    width: 150,
    height: 150,
    shapeType: "round",
    borderRadius:"50%",
    iconColor: "#e9e9e9"
  }
]

/**
 * app图片默认配置数据
 */
export const appHome = [
  {},
  {
    styleId:2,
    shapeType: "radius", // square， radius， round
    borderRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10
  },
  {
    styleId:3,
    height: 200,
    shapeType: "rect"
  },
  {
    styleId:4,
    height: 200,
    shapeType: "round", // square， radius， round
    borderRadius: "50%",
    borderTopLeftRadius: "50%",
    borderTopRightRadius: "50%",
    borderBottomLeftRadius: "50%",
    borderBottomRightRadius: "50%"
  }
]

